export { default as ListaView } from 'modules/reportes/components/lista';
//export {default as LogsC} from 'modules/registros/components/logs';



// WEBPACK FOOTER //
// src/modules/reportes/component.js